import Members from "../views/Components/MemberComponent/Index";
import roleIcon from "assets/img/svg/role.svg";
import UserRole from "../views/Components/UserRolesComponent";
import membersIcon from "assets/img/svg/value.svg";
import passwordPurpleIcon from "assets/img/svg/password-purple.svg";
import passwordCreamIcon from "assets/img/svg/password-cream.svg";
import dashboardPurpleIcon from "assets/img/svg/dashboard-purple.svg";
import dashboardCreamIcon from "assets/img/svg/dashboard-cream.svg";
import organisationPurpleIcon from "assets/img/svg/organisation-purple.svg";
import organisationCreamIcon from "assets/img/svg/organisation-cream.svg";
import partnerCreamIcon from "assets/img/svg/partner-cream.svg";
import partnerPurpleIcon from "assets/img/svg/partner-purple.svg";
import alertPurpleIcon from "assets/img/svg/alert-purple.svg";
import alertCreamIcon from "assets/img/svg/alert-cream.svg";
import DashboardIcon from "assets/img/svg/value.svg";
import ChangePassword from "../views/Components/UpdatePasswordComponent";
import Dashboard from "../views/Components/MainDashboardComponent";
import Partner from "../views/Components/PartnerComponent";
import PartnerUsers from "../views/Components/PartnerComponent/PartnerUsersComponent";
import Organisation from "../views/Components/OrganisationComponent";
import notificationCreamIcon from 'assets/img/svg/Argos - Notifications - Alt Cream.svg';
import notificationPurpleIcon from 'assets/img/svg/Argos - Notifications - Purple.svg';
import OrganisationDashboard from "../views/Components/OrganisationComponent/Dashboard";
import Team from "../views/Components/TeamComponent";
import perspectivesPurpleIcon from "assets/img/svg/perspectives-purple.svg";
import perspectivesCreamIcon from "assets/img/svg/perspectives-cream.svg";
import TeamsDashboard from "../views/Components/TeamComponent/Dashboard";
import TeamUsers from "../views/Components/TeamMembersComponent";
import Rules from "../views/Components/RulesComponent";
import RulesDashboard from "../views/Components/RulesComponent/Dashboard";
import IssuesComponent from "../views/Components/IssuesComponent";
import IssueDetailsComponent from "../views/Components/IssueDetailsComponent";
import Instance from "../views/Components/InstanceComponent";
import InstanceDashboard from "../views/Components/InstanceComponent/Dashboard";
import Agent from "../views/Components/AgentComponent";
import Notification from "../views/Components/NotificationComponent";
import UserProfile from "../views/Components/UserProfileComponent";
import Information from "../views/Components/InformationComponent";
import Reporting from "../views/Components/ReportComponent";
import Notifications from "../views/Components/Notifications";
// import AgentDashboard from "../views/Components/AgentComponent/Dashboard";

import Perspectives from "../views/Components/PerspectivesComponent/Index";
let dashRoutes = [
  {
    path: "/dashboard/home", //for dashboard purpose
    name: "Dashboard",
    mini: "DP",
    icon: dashboardPurpleIcon,
    iconInactive: dashboardPurpleIcon,
    iconActive: dashboardCreamIcon,
    component: Dashboard,
  },
  {
    path: "/dashboard/partner", //for partners tab purpose
    name: "Partners",
    mini: "PP",
    icon: partnerPurpleIcon,
    iconInactive: partnerPurpleIcon,
    iconActive: partnerCreamIcon,
    component: Partner,
  },
  {
    path: "/dashboard/organisations/:id", //for partners to organisations purpose
    mini: "CP",
    icon: roleIcon,
    component: Organisation,
  },
  {
    path: "/dashboard/organisations", //for only organisations tab purpose
    name: "Organisations",
    mini: "CP",
    icon: organisationPurpleIcon,
    iconInactive: organisationPurpleIcon,
    iconActive: organisationCreamIcon,
    component: Organisation,
  },
  {
    path: "/dashboard/organisationDashboard/:id", //for organisation dashboard purpose
    mini: "CP",
    icon: roleIcon,
    component: OrganisationDashboard,
  },
  {
    path: "/dashboard/teams/:id", //for teams purpose
    mini: "CP",
    icon: DashboardIcon,
    component: Team,
  },
  {
    path: "/dashboard/teamDashboard/:id", //for teams dashboard purpose
    mini: "MP",
    icon: membersIcon,
    component: TeamsDashboard,
  },
  {
    path: "/dashboard/roles/:role/:id", //for roles purpose
    mini: "RP",
    icon: roleIcon,
    component: UserRole,
  },
  {
    path: "/dashboard/members/:role/:id", //for members purpose
    mini: "MP",
    icon: membersIcon,
    component: Members,
  },
  {
    path: "/dashboard/teamUsers/:id", //for team users purpose
    mini: "MP",
    icon: membersIcon,
    component: TeamUsers,
  },
  {
    path: "/dashboard/issues/:id", //for issues purpose
    mini: "MP",
    icon: membersIcon,
    component: IssuesComponent,
  },
  {
    path: "/dashboard/issues", //for issues page
    name: "Alerts",
    mini: "CP",
    icon: alertPurpleIcon,
    iconInactive: alertPurpleIcon,
    iconActive: alertCreamIcon,
    component: IssuesComponent,
  },
  {
    path: "/dashboard/perspectives", // for perspectives page
    name: "Perspectives",
    mini: "CP",
    icon: perspectivesPurpleIcon,
    iconInactive: perspectivesPurpleIcon,
    iconActive: perspectivesCreamIcon,
    component: Perspectives,
  },
  {
    path: "/dashboard/notifications", // for notifications page
    name: "Notifications",
    mini: "CP",
    icon: notificationPurpleIcon,
    iconInactive: notificationPurpleIcon,
    iconActive: notificationCreamIcon,
    component: Notifications,
    count: "Bubble"
  },
  // {
  //   path: "/dashboard/globalusers", //for global user tab purpose
  //   name: "Global Users",
  //   mini: "MP",
  //   icon: GlobalUsersIcon,
  //   component: Members
  // },
  {
    path: "/dashboard/issueDetails/:id", //for issue details purpose
    mini: "MP",
    icon: membersIcon,
    component: IssueDetailsComponent,
  },
  {
    path: "/dashboard/instances/:id", //for instance purpose
    mini: "CP",
    icon: DashboardIcon,
    component: Instance,
  },
  {
    path: "/dashboard/InstanceDashboard/:id", //for instance dashboard purpose
    mini: "MP",
    icon: membersIcon,
    component: InstanceDashboard,
  },
  {
    path: "/dashboard/rules/:id", //for rules with id purpose
    mini: "MP",
    icon: membersIcon,
    component: Rules,
  },
  {
    path: "/dashboard/ruleDashboard/:id", //for rules dashboard purpose
    mini: "MP",
    icon: membersIcon,
    component: RulesDashboard,
  },
  {
    path: "/dashboard/notification/:id", //for notification purpose
    mini: "NC",
    icon: membersIcon,
    component: Notification,
  },
  {
    path: "/dashboard/agents/:id", //for agent purpose
    mini: "CP",
    icon: DashboardIcon,
    component: Agent,
  },
  // {
  //   path: "/dashboard/agentsDashboard/:id", //for agent dashboard purpose
  //   mini: "MP",
  //   icon: membersIcon,
  //   component: AgentDashboard
  // },
  {
    path: "/dashboard/partnerUsers/:id",
    mini: "PUP",
    icon: roleIcon,
    component: PartnerUsers,
  },
  {
    path: "/dashboard/teams",
    mini: "CP",
    icon: DashboardIcon,
    component: Team,
  },
  {
    path: "/dashboard/update-password", //for update password
    name: "Change password",
    mini: "CP",
    icon: passwordPurpleIcon,
    iconInactive: passwordPurpleIcon,
    iconActive: passwordCreamIcon,
    component: ChangePassword,
  },
  {
    path: "/dashboard/user-profile", //for user profile
    mini: "UP",
    icon: passwordPurpleIcon,
    component: UserProfile,
  },
  {
    path: "/dashboard/info/:id", //for information page
    mini: "IP",
    icon: roleIcon,
    component: Information,
  },
  {
    path: "/dashboard/report/:id", //for report page
    mini: "RP",
    icon: roleIcon,
    component: Reporting,
  },
  //{ redirect: true, path: "/", pathTo: "/dashboard", name: "Dashboard" }
];
export default dashRoutes;
